import StyledHeadingText from '../../components/Fonts/StyledHeadingText';

function OrderRewardPointPopView({ item }) {
    const getTypeColor = (type) => {
        switch (type) {
            case 'earned':
                return {
                    bg: 'bg-green-50',
                    border: 'border-green-200',
                    text: 'text-green-700',
                    badge: 'bg-green-100',
                    icon: '🏆',
                    sign: '+'
                };
            case 'used':
                return {
                    bg: 'bg-red-50',
                    border: 'border-red-200',
                    text: 'text-red-700',
                    badge: 'bg-red-100',
                    icon: '📉',
                    sign: '-'
                };
            case 'refunded':
                return {
                    bg: 'bg-blue-50',
                    border: 'border-blue-200',
                    text: 'text-blue-700',
                    badge: 'bg-blue-100',
                    icon: '↩',
                    sign: '↩'
                };
            default:
                return {
                    bg: 'bg-gray-50',
                    border: 'border-gray-200',
                    text: 'text-gray-700',
                    badge: 'bg-gray-100',
                    icon: '❓',
                    sign: ''
                };
        }
    };

    const getTypeLabel = (type) => {
        switch (type) {
            case 'earned':
                return 'Earned';
            case 'used':
                return 'Used';
            case 'refunded':
                return 'Refunded';
            default:
                return type?.toUpperCase() || 'Unknown';
        }
    };

    // Calculate totals
    const earnedPoints = item?.reward_points?.filter(rp => rp.type === 'earned').reduce((sum, rp) => sum + (rp.points || 0), 0) || 0;
    const usedPoints = item?.reward_points?.filter(rp => rp.type === 'used').reduce((sum, rp) => sum + (rp.points || 0), 0) || 0;
    const refundedPoints = item?.reward_points?.filter(rp => rp.type === 'refunded').reduce((sum, rp) => sum + (rp.points || 0), 0) || 0;

    return (
        <div className="w-full flex-1">
            <div className="flex flex-row justify-between mt-2 items-center mb-3">
                <div className="flex flex-row gap-2">
                    <StyledHeadingText text="Reward Points" TextColor={"text-gray-500 font-normal"} />
                </div>
            </div>

            {/* Summary Cards */}
            {item?.reward_points && item.reward_points.length > 0 && (
                <div className="grid grid-cols-3 gap-3 mb-4">
                    <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                        <div className="text-xs text-green-600 mb-1">Total Earned</div>
                        <div className="text-lg font-bold text-green-700">+{earnedPoints}</div>
                    </div>
                    <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                        <div className="text-xs text-red-600 mb-1">Total Used</div>
                        <div className="text-lg font-bold text-red-700">-{usedPoints}</div>
                    </div>
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                        <div className="text-xs text-blue-600 mb-1">Total Refunded</div>
                        <div className="text-lg font-bold text-blue-700">↩{refundedPoints}</div>
                    </div>
                </div>
            )}

            {/* Reward Points List */}
            {item?.reward_points && item.reward_points.length !== 0 ? (
                <div className="flex flex-col overflow-y-auto gap-3 mt-2 max-h-[400px]">
                    {item.reward_points.map((rewardPointItem, index) => {
                        const colors = getTypeColor(rewardPointItem.type);
                        return (
                            <div 
                                key={index} 
                                className={`p-4 rounded-lg border ${colors.border} ${colors.bg} shadow-sm hover:shadow-md transition-shadow`}
                            >
                                <div className="flex flex-row items-center justify-between gap-4">
                                    <div className="flex items-center gap-3 flex-1">
                                        {/* Icon */}
                                        <div className={`w-10 h-10 ${colors.badge} rounded-lg flex items-center justify-center flex-shrink-0`}>
                                            <span className="text-lg">{colors.icon}</span>
                                        </div>
                                        
                                        {/* Details */}
                                        <div className="flex-1 min-w-0">
                                            <div className="flex items-center gap-2 mb-1">
                                                <span className={`text-xs font-semibold ${colors.text} ${colors.badge} px-2 py-1 rounded-full`}>
                                                    {getTypeLabel(rewardPointItem.type)}
                                                </span>
                                            </div>
                                            <div className={`text-xl font-bold ${colors.text}`}>
                                                {colors.sign}{rewardPointItem.points || 0} Points
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div className="text-center py-8 text-gray-500 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="text-4xl mb-2">🏆</div>
                    <div className="text-sm">No reward points available for this order</div>
                </div>
            )}
        </div>
    );
}

export default OrderRewardPointPopView;
